module.exports = __webpack_public_path__ + "static/media/a-smarter-harvest-tablet.2d1be2e3.jpg";